import { Record } from "immutable";

const defaultRecord = {
  source: null, // could be user or broadcast
  value: null,
  editMode: false,
};

const RecordMap = Record(defaultRecord, "TitleEditorState");

export default class TitleState {
  constructor(recordMap) {
    this.recordMap = recordMap;
  }

  getRecordMap() {
    return this.recordMap;
  }

  static create(data) {
    return new TitleState(new RecordMap(data));
  }

  static set(titleState, object) {
    const map = titleState.getRecordMap().withMutations((state) => {
      return state.merge(object);
    });
    return TitleState.create(map);
  }

  getSource() {
    return this.recordMap.get("source");
  }

  getValue() {
    return this.recordMap.get("value");
  }

  getEditMode() {
    return this.recordMap.get("editMode");
  }

  toJS() {
    return this.getRecordMap().toJS();
  }
}
